
import React from "react";
import {
  Box,
  Typography,
  Grid,
  Container,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";
import app from "../assets/app.png";
import logo from "../assets/mission.png";

const AboutUs = () => {
  return (
    <>
      <Header />
      <Box
        sx={{
          minHeight: "50vh",
          background:
            "linear-gradient(135deg, #0D2A54 0%, #1A4B83 50%, #2B6BA5 100%)",
          display: "flex",
          alignItems: "center",
          // position: "relative",

        }}
      >
        <Container
          sx={{ position: "relative", zIndex: 1, textAlign: "center" }}
        >
          <Typography
            variant="h2"
            sx={{
              color: "white",
              fontWeight: 800,
              fontSize: { xs: "2.2rem", md: "3rem", lg: "4rem" },
              mb: 3,
              textShadow: "0 4px 8px rgba(0,0,0,0.3)",
            }}
          >
            Empowering Student Futures
          </Typography>
          <Typography
            sx={{
              color: "white",
              maxWidth: 800,
              mx: "auto",
              mb: 5,
              fontWeight: 300,
              lineHeight: 1.6,
              fontSize: { xs: "1rem", md: "1.2rem" },
            }}
          >
            GetMyRank is a non-profit educational initiative
            <span
              style={{
                color: "#FFD700",
                fontWeight: 900,
                marginLeft: "6px",
                marginRight: "6px",
                // textDecoration: "underline",
                // textUnderlineOffset: "4px",
              }}
            >
              (NGO)
            </span>
            providing 100% FREE study materials from SSLC to Master’s level.
          </Typography>


          <Button
            variant="contained"
            size="large"
            component="a"
            href="https://play.google.com/store/apps/details?id=com.getmyrank&hl=en"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              px: 5,
              py: 1.8,
              fontSize: "1rem",
              fontWeight: 700,
              borderRadius: 50,
              bgcolor: "white",
              color: "#1A4B83",
              boxShadow: "0 8px 32px rgba(255,255,255,0.3)",
              "&:hover": {
                bgcolor: "#f8fafc",
                transform: "translateY(-2px)",
                boxShadow: "0 12px 40px rgba(255,255,255,0.4)",
              },
            }}
          >
            Download GetMyRank
          </Button>
        </Container>
      </Box>

      {/* Mission Section */}

      <Grid container spacing={6} alignItems="center" sx={{ p: { xs: 2, md: 10 } }}>
        <Grid size={{ xs: 12, md: 6, sm: 6 }}>
          <Box
            component="img"
            src={logo}
            alt="GetMyRank Mission"
            sx={{
              width: "100%",
              height: { xs: 200, md: "auto" },
              borderRadius: 10,
              boxShadow: "0 20px 60px rgba(13,42,84,0.15)",
              objectFit: "cover",
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6, sm: 6 }}>
          <Typography

            sx={{
              color: "#1A4B83", fontWeight: 700, mb: 2, fontSize: { xs: 25, md: 35 }, borderBottom: "4px solid #1A4B83",

              width: "fit-content",
              // mx: "auto",

            }}
          >
            Our Mission
          </Typography>
          <Typography
            sx={{
              color: "#475569",
              mb: 4,
              lineHeight: 1.8,
              fontSize: "1.1rem",
              textAlign: 'justify'
            }}
          >
            GetMyRank is a non-profit educational organization committed to
            bridging the education gap by delivering high-quality learning resources at no
            cost. We provide 100% FREE study materials from SSLC to Master’s level, along
            with career guidance and academic support. Through college outreach programs,
            counseling initiatives, and our digital learning platform, we strive to ensure
            equal educational opportunities for every student, regardless of background or
            financial status.

          </Typography>
        </Grid>
      </Grid>

      {/* App Showcase Section */}
      <Box
        sx={{
          py: { xs: 8, md: 12 },
          background: "linear-gradient(135deg, #f0f4ff 0%, #e0ebff 100%)",
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={6} >
            {/* App Screenshot */}
            <Grid size={{ xs: 12, md: 4, sm: 4 }}>
              <Box
                component="img"
                src={app}
                alt="GetMyRank App"
                sx={{
                  width: "100%",
                  // maxWidth: 350,
                  // height:700,
                  mx: "auto",
                  borderRadius: 3,
                  boxShadow: "0 20px 60px rgba(26,75,131,0.15)",
                }}
              />
            </Grid>

            {/* App Features */}
            <Grid size={{ xs: 12, md: 8, sm: 8 }}>
              <Typography
                variant="h3"
                sx={{
                  color: "#1A4B83",
                  fontWeight: 700,
                  textAlign: "center",
                  mb: 5,
                  mt: { xs: 0, md: 5 },
                  fontSize: { xs: "2rem", md: "2.8rem" },
                  borderBottom: "4px solid #1A4B83",

                  width: "fit-content",
                }}
              >
                All-in-One Learning App
              </Typography>
              <List>
                <ListItem sx={{ py: 1 }}>
                  <ListItemIcon sx={{ color: "#2B6BA5", minWidth: 40 }}>
                    📚
                  </ListItemIcon>
                  <ListItemText
                    primary="SSLC to Master's Notes & Syllabus"
                    secondary="Access all subjects, chapter-wise notes, and complete syllabus in one app."
                  />
                </ListItem>
                <ListItem sx={{ py: 1 }}>
                  <ListItemIcon sx={{ color: "#2B6BA5", minWidth: 40 }}>
                    📝
                  </ListItemIcon>
                  <ListItemText
                    primary="Practice Papers & Previous Year Questions"
                    secondary="Solve questions, test yourself, and track progress easily."
                  />
                </ListItem>
                <ListItem sx={{ py: 1 }}>
                  <ListItemIcon sx={{ color: "#2B6BA5", minWidth: 40 }}>
                    🎓
                  </ListItemIcon>
                  <ListItemText
                    primary="Learning Solutions & Career Guidance"
                    secondary="Plan your studies, get recommendations, and career counseling."
                  />
                </ListItem>
                <ListItem sx={{ py: 1 }}>
                  <ListItemIcon sx={{ color: "#2B6BA5", minWidth: 40 }}>
                    💯
                  </ListItemIcon>
                  <ListItemText
                    primary="100% Free Access"
                    secondary="All study materials and guidance are completely free forever."
                  />
                </ListItem>
              </List>

              <Box sx={{ mt: 4, ml: { xs: 3, md: 5 } }}>
                <Button
                  variant="contained"
                  size="large"
                  component="a"
                  href="https://play.google.com/store/apps/details?id=com.getmyrank&hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    px: 6,
                    py: 1.8,
                    fontSize: { xs: 15, md: 20 },
                    fontWeight: 700,
                    borderRadius: 50,
                    bgcolor: "#1A4B83",
                    color: "white",
                    boxShadow: "0 8px 30px rgba(26,75,131,0.3)",
                    "&:hover": {
                      bgcolor: "#2B6BA5",
                      transform: "translateY(-2px)",
                      boxShadow: "0 12px 40px rgba(26,75,131,0.4)",
                    },
                  }}
                >
                  Download the App
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* How to Use Section */}
      <Container maxWidth="lg" sx={{ py: { xs: 8, md: 12 } }}>
        <Typography
          variant="h3"
          sx={{
            color: "#1A4B83",
            fontWeight: 700,
            textAlign: "center",
            mb: 6,
            fontSize: { xs: "2rem", md: "2.8rem" },
            borderBottom: "4px solid #1A4B83",
            mx: 'auto',
            width: "fit-content",
          }}
        >
          How to Use the App
        </Typography>

        <Grid container spacing={6}>
          {[
            {
              step: "1",
              title: "Download & Install",
              desc: "Get the app from Play Store and install it on your device.",
            },
            {
              step: "2",
              title: "Sign Up",
              desc: "Create your free account to access all features.",
            },
            {
              step: "3",
              title: "Explore Materials",
              desc: "Access SSLC to Master's notes, syllabus, and papers.",
            },
            {
              step: "4",
              title: "Track Progress",
              desc: "Solve questions and monitor your performance.",
            },
          ].map((item, index, arr) => (
            <Grid key={item.step} size={{ xs: 12, md: 3, md: 3 }}>
              <Box
                sx={{
                  position: "relative",
                  textAlign: "center",
                  p: 4,

                  borderRadius: 3,
                  bgcolor: "#f0f4ff",
                  boxShadow: "1 10px 30px rgba(43,107,165,0.1)",
                  height: 150,

                  /* LINE CONNECTOR */
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    top: "50%",
                    right: "-60px",
                    width: "60px",
                    height: "4px",
                    bgcolor: "#1A4B83",
                    display: {
                      xs: "none",
                      md: index !== arr.length - 1 ? "block" : "none",
                    },
                  },
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ color: "#1A4B83", fontWeight: 700, mb: 1 }}
                >
                  {item.step}
                </Typography>

                <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                  {item.title}
                </Typography>

                <Typography sx={{ color: "#475569", fontSize: "1rem" }}>
                  {item.desc}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Benefits Section */}
      <Box
        sx={{
          py: { xs: 8, md: 12 },
          background: "linear-gradient(135deg, #f0f4ff 0%, #e0ebff 100%)",
          color: "white",
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              textAlign: "center",
              color: "#1A4B83",
              mb: 6,
              fontSize: { xs: "2rem", md: "2.8rem" },
              borderBottom: "4px solid #1A4B83",
              mx: 'auto',
              width: "fit-content",
            }}
          >
            Benefits of GetMyRank
          </Typography>
          <Grid container spacing={6}>
            {[
              "Access all syllabus and notes from SSLC to Master's",
              "Practice papers and previous year questions",
              "Career guidance and learning solutions",
              "Completely free forever, no hidden costs",
            ].map((benefit, index) => (
              <Grid size={{ xs: 12, md: 3, sm: 4 }} key={index}>
                <Box
                  sx={{
                    textAlign: "center",
                    p: 2,
                    borderRadius: 3,
                    bgcolor: "#2B6BA5",
                  }}
                >
                  <Typography variant="h5" sx={{ fontWeight: 900, mb: 1, color: "#fff", }}>
                    {index + 1}
                  </Typography>
                  <Typography sx={{ fontSize: "1rem", color: "#fff", }}>{benefit}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Footer />
    </>
  );
};

export default AboutUs;
